/**
 * @typedef {Object} enum
 * @property {string} M_BASIC 创意绘图(基础版)
 * @property {string} M_ADVANCED 创意绘图(高级版)
 * @property {string} T_BASIC_TTI 文生图(基础版)
 * @property {string} T_BASIC_ITI 图生图(基础版)
 * @property {string} T_SD_TTI 文生图(SD)
 * @property {string} T_SD_ITI 图生图(SD)
 * @property {string} T_FLUX_TTI 文生图(Flux)
 * @property {string} T_FLUX_ITI 图生图(Flux)
 * @property {string} T_BACKGROUND_REMOVE 智能抠图
 * @property {string} T_IMAGE_SCALING 智能扩图
 * @property {string} T_QUALITY_OPT AI超清
 */

const enumUtil = {}
enumUtil.install = (Vue, data) => {
  const enums = { ...data.enumModules }
  enums.all_maps = data.enumMaps

  enums.getDescByValue = (enumName, value) => {
    if (!enums.all_maps[enumName]) {
      return ''
    }

    const thisEnum = enums.all_maps[enumName]
    if (!thisEnum[value]) {
      return ''
    }

    return thisEnum[value].desc
  }
  /**
   * 全局枚举-内置变量
   * @type enum
   */
  Vue.prototype.$enum = enums
}

export default enumUtil
